import { Trans, useTranslation } from "react-i18next";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { titleCaseToTitle } from "services/util";

export const MainErrors = ({ details, showWarnings, typeOfInv, justMessages=false }) => {

  const { t } = useTranslation()

  const styleL = {
    className: "mb-0 pl-3 text-left"
  }

  const styleLi = {
    className: "mb-2"
  }

  const styleB = {
    style: { fontSize: "1.2em" },
    className: "mb-1 text-center"
  }

  const detailsValid = details?.validationResults;

  const noApp = details?.errors === "No Zatca app is installed"

  const fieldMissing = typeof details?.errors === 'object';
  const generic_error = typeof details?.errors === 'string'

  const reportingStatus = details?.reportingStatus || (!details?.reportingStatus && details?.validationResults?.status==='PASS'? "REPORTED" : "NOT REPORTED");
  const clearStatus = details?.clearanceStatus;
  const isCleared = clearStatus === "CLEARED"
  const isReported = reportingStatus === "REPORTED"
  const textContent = isReported ? 'Reported' : 'Not Reported';
  const textCont = isCleared ? 'Cleared' : 'Not Cleared';

  return (
      <div>
        {details && (
          <>
          {!justMessages && <>

            <div className="mb-4">

              {!fieldMissing ?
                <>
                  {clearStatus ? (
                    <div className={`alert ${isCleared ? 'alert-success' : 'alert-danger'}`} role="alert">
                      <p {...styleB}><strong>{textCont}</strong></p>
                      {details?.message && <p {...styleB}><strong>{details?.message}</strong></p>}
                    </div>
                  ) : (

                    <div className={`alert ${isReported ? 'alert-success' : 'alert-danger'}`} role="alert">
                      <p {...styleB}><strong>{typeOfInv}{textContent}</strong></p>
                      {details?.message && <p {...styleB}><strong>{details?.message}</strong></p>}
                    </div>)}
                    <p {...styleB}><Trans>Status:</Trans> <strong>{detailsValid?.status || (noApp ? <Trans>NOT CONNECTED</Trans> : <Trans>NOT SENT</Trans>)}</strong></p>
                </>
                :
                <div className={`alert alert-danger`} role="alert">
                  <p {...styleB}><strong><Trans>Invoice is not Set Properly</Trans></strong></p>
                </div>
              }

              <h5 className="mt-3"><Trans>Detailed Messages:</Trans></h5>
            </div>
            
            </>}

            {noApp &&
              <div className="alert alert-danger" role="alert">
                <ul {...styleL}>
                  <li {...styleLi}><Trans><strong>ERROR: </strong>Couldn't connect to Zatca. Please make sure you are Onboarded and have a valid connection.</Trans></li>
                </ul>
              </div>}
            {fieldMissing && Object.entries(details.errors).map(([fieldName, fieldValue]) => (
              <div className="alert alert-danger" role="alert">
                <ul {...styleL}>
                  {/* <li {...styleLi} key={fieldName}><Trans><strong>ERROR: </strong>{titleCaseToTitle(fieldName)} is not assigned. Please make sure all the details are valid and present.</Trans></li> */}
                  <li {...styleLi} key={fieldName}><Trans><strong>Input Validation: </strong>{titleCaseToTitle(fieldName)} {fieldValue}</Trans></li>
                </ul>
              </div>
            ))}

            {detailsValid?.errorMessages && detailsValid.errorMessages.length > 0 &&
              <div className="alert alert-danger" role="alert">
                <ul {...styleL}>
                  {detailsValid.errorMessages.map((error, index) => (
                    <li {...styleLi} key={index}>
                      <strong>{error.type}:</strong> {error.code} - {error.message}
                    </li>
                  ))}
                </ul>
              </div>}

            {showWarnings && detailsValid?.warningMessages && detailsValid.warningMessages.length > 0 &&
              <div className="alert" role="alert" style={{ color: '#856404', backgroundColor: '#fff3cd', borderColor: '#ffeeba' }}>
                <ul {...styleL}>
                  {detailsValid.warningMessages.map((warning, index) => (
                    <li {...styleLi} key={index}>
                      <strong>{warning.type}:</strong> {warning.code} - {warning.message}
                    </li>
                  ))}
                </ul>
              </div>}

            {detailsValid?.infoMessages && detailsValid.infoMessages.length > 0 &&
              <div className="alert alert-info" role="alert">
                <ul {...styleL}>
                  {detailsValid.infoMessages.map((info, index) => (
                    <li {...styleLi} key={index}>
                      <strong>{info.type}:</strong> {info.code} - {info.message}
                    </li>
                  ))}
                </ul>
              </div>}

            {generic_error && <div className="alert alert-danger" role="alert">
              <ul {...styleL}>
                <li {...styleLi}>{details.errors}</li>
              </ul>
            </div>}
          </>
        )}
      </div>
  );
};

export const ErrorDetailsComponent = ({ show, handleClose, details, showWarnings, typeOfInv, reload }) => {

  return (
    <Modal isOpen={show} toggle={handleClose} contentLabel="Detailed Response" onExit={reload}>
      <ModalHeader toggle={handleClose}><Trans>Response Details</Trans></ModalHeader>
      <ModalBody>
        <MainErrors details={details} showWarnings={showWarnings} typeOfInv={typeOfInv}/>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={handleClose}>
          <Trans>Close</Trans>
        </Button>
      </ModalFooter>
    </Modal>
  );
};